<div class="h-100">
    <div class="mf-grid" [ngClass]="{ 'mf-min-menu ': min, 'mf-no-header': submenu.length < 1 }">
        <lay-menu (onMenuSizeChange)="min = $event" class="mf-menu"></lay-menu>

        <lay-sub-menu [sumbMenu]="submenu" class="mf-header"></lay-sub-menu>

        <div class="mf-content"><router-outlet (activate)="activate($event)"></router-outlet></div>
    </div>
</div>
